import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  palette: {
    brand: {
      main: '#F8DA5A'
    },
    textAndLabels: {
      main: '#2F2F2F',
      secondary: '#555555',
      tertiary: '#989898',
      quaternary: '#C69C00',
      approved: '#3DB460',
      rejected: '#FF586D',
      pending: '#C69C00',
      expired: '#2F2F2F',
      premium: 'linear-gradient(180deg, #F8F8F8 0%, #C1C1C1 100%)',
      blue: '#007BE5',
      dark: '#2F2F2F',
      primary: '#212C3A',
      bump: 'linear-gradient(180deg, #EEFFF5 0%, #EFF2FC 50%, #E4F5FF 100%)'
    },
    bg: {
      resumeCard: '#FBFBFB',
      main: '#FCFCFC',
      secondary: '#F6F7FA',
      tertiary: '#FFEEA5',
      card: '#F7F7F7',
      approved: '#C9F4D6',
      rejected: '#FFDCE0',
      pending: '#FFEEA5',
      expired: '#DBDBDB',
      user: '#F8DA5A',
      section: '#DFE5E4',
      premium: '#C8EF01'
    },
    system: {
      deepBlue: '#4264FD',
      blue: '#4C88F9',
      lightBlue: '#DAE8FF',
      green: '#3DB460',
      red: '#FF586D',
      yellow: '#FFB900',
      white: '#FFFFFF',
      black: '#1A1A1A',
      brand: '#F8DA5A'
    },
    border: {
      main: '#DBDBDB',
      primary: '#EAEBF2',
      secondary: '#EAEBF2',
      tertiary: '#DFE3E9',
      dark: '#2F2F2F'
    },
    shadow: {
      main: '#2F2F2F',
      accent: '#2F2F2F'
    }
  }
};
